module.exports = __webpack_public_path__ + "static/media/entregas.da7813ac.png";